(function () {
  function initReviews() {
    window.__productReviewSettings = {
      brandId: '12fd7f8e-97ee-413b-8c40-2c408aa70e7b'
    };

    window.__productReviewCallbackQueue = window.__productReviewCallbackQueue || [];
    window.__productReviewCallbackQueue.push(function (ProductReview) {
      ProductReview.use('reviews-horizontal', {
        container: '#koc-pr-reviews-widget',
        identificationDetails: {
          type: 'single',
          strategy: 'from-internal-entry-id',
          identifier: 'a4f76037-ce66-5ee6-b547-1ff3291e2dfc'
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviews);
  } else {
    initReviews();
  }
})();